define([
    "core/urls",
    "core/utilities",
    'components/modal',
], function (
    urls,
    utilities,
    modal
) {

    let nodes = {
        main: document.querySelector(".data-manager.sb-page"),
        typeSelectionWrapper: document.querySelector(".type-selections"),
        typeSelections: document.querySelectorAll(".type-selections .type"),
        typeSlider: document.querySelector(".type-slider"),
        table: document.querySelector(".table"),
        dataTableHeader: document.querySelector(".data-wrapper .table .header"),
        dataList: document.querySelector(".data-wrapper .table .list"),
        showHiddenOnly: document.querySelector("#show-hidden-only"),
        showHiddenOnlySpan: document.querySelector(".show-hide-wrapper .description span"),
        search: document.querySelector(".search-bar"),
        discardChanges: document.querySelector(".discard-changes"),
        saveChanges: document.querySelector(".save-changes"),
        loaderElement: document.querySelector(".marketing-loader"),
        modal: {
            modal: document.querySelector(".modal_js"),
            close: document.querySelector(".modal-close_js"),
            content: document.querySelector(".modal-content_js"),
            title: document.querySelector(".modal-title_js"),
            bg: document.querySelector(".modal-bg_js"),
            blur: [
                document.querySelector(".data-manager"),
                document.querySelector(".sidebar-nav"),
                document.querySelector(".navigation-top")
            ],
        },
    }

    let modifiedData = [];
    let createdModal = modal.create(nodes.modal, function (el) {});
    let modalTemplate = document.querySelector(".modal-template-discard-changes");
    let subscriptions = [];
    let csrfToken = document.querySelector("[name='csrfmiddlewaretoken']").value;

    if(nodes.main.dataset.csatCustomer === "True") subscriptions.push("csat");
    if(nodes.main.dataset.npsCustomer === "True") subscriptions.push("nps");
    if(nodes.main.dataset.projectsCustomer === "True") subscriptions.push("projects");

    let dataStore = {
        "companies": [],
        "agents": [],
        "boards": []
    }

    let initialData = JSON.parse(JSON.stringify(dataStore));
        // create duplicate data object for reverting user changes 

    let userAdminPermissions = [];
    if(nodes.main.dataset.csatAdmin === "True") userAdminPermissions.push("csat");
    if(nodes.main.dataset.npsAdmin === "True") userAdminPermissions.push("nps");
    if(nodes.main.dataset.projectsAdmin === "True") userAdminPermissions.push("projects");

    let boardName = nodes.typeSelectionWrapper.querySelector("div.type[data-type='boards']").innerText;

    let namingMap = {
        "companies": "Companies",
        "agents": "Agents",
        "boards": boardName,
        "csat_title": "Hide in CSAT",
        "nps_title": "Hide in NPS",
        "projects_title": "Hide in Project Surveys"
    }

    dataConfig = {
        "showHiddenOnly" : false,
        "query": "",
        "type": "companies"
    }

    let updateButtonStates = () => {
        if(modifiedData.length) {
            nodes.discardChanges.classList.remove("disabled");
            nodes.saveChanges.classList.remove("disabled");
        } else {
            nodes.discardChanges.classList.add("disabled");
            nodes.saveChanges.classList.add("disabled");
        }
    }

    let discardChanges = (resetDataStore) => {
        // reset modified data
        modifiedData = []; 

        if(resetDataStore) {
            // reset data object for this sectino to initial state
            dataStore[dataConfig.type] = JSON.parse(JSON.stringify(initialData[dataConfig.type])); 
        }
        
        // reset slider config
        typeSliderConfig.preventSlide = false;
        updateButtonStates();
    }

    let renderList = async () => {
        if(!dataStore[dataConfig.type].length) {
            await fetch(urls['configuration:data-manager-data'](dataConfig.type), {
                method: "GET",
            }).then(response => response.json())
            .then((data) => {
                dataStore[dataConfig.type] = data;
                initialData[dataConfig.type] = JSON.parse(JSON.stringify(data));
            });
        }
        
        nodes.loaderElement.classList.remove("disabled");
        // only "Companies" appear outside of CSAT and require multiple checkbox columns
        let checkboxesToRender = dataConfig.type === "companies" ? subscriptions : ["csat"];

        if(checkboxesToRender.length === 1) {
            nodes.table.classList.add("single-checkbox-column");
        } else {
            nodes.table.classList.remove("single-checkbox-column");
        }

        if(checkboxesToRender.length === 2) {
            nodes.table.classList.add("triple-checkbox-column");
        } else {
            nodes.table.classList.remove("triple-checkbox-column");
        }
        
        // render checkboxes for table header
        let checkboxHeaders = checkboxesToRender.map(checkbox => {
            return `<div class="checkbox-title ${userAdminPermissions.includes(checkbox) ? "" : "disabled"}">
                        ${namingMap[checkbox+"_title"]}
                    </div>`
        }).join('');

        let selectAllCheckbox = dataConfig.type === "companies" && subscriptions.length > 1 ? `<div class="checkbox-title">Select All</div>` : '';

        // render table header
        let header = `
            <div class="title">${namingMap[dataConfig.type]}</div>
            ${checkboxHeaders}
            ${selectAllCheckbox}
        `

        // render table data
        let dataList = dataStore[dataConfig.type].map((item, i) => {
            let checkboxIsAvailable = false; // used to determine if "select all" should be clickable
            let hasHiddenSelections = false; // used to filter by 'showHiddenOnly'
            let allCheckboxesSelected = true; // used to determine whether or not to check the 'All' checkbox
            let checkboxes = checkboxesToRender.map(checkboxType => {
                if(!(checkboxType in item.hidden)) return "<div class='no-record'>—</div>";

                if(item.hidden[checkboxType]) hasHiddenSelections = true;

                if(userAdminPermissions.includes(checkboxType)) {
                    checkboxIsAvailable = true;

                    if (item.hidden[checkboxType] === false) {
                        allCheckboxesSelected = false;
                    }
                }
                

                return `<input type="checkbox"  
                            class="type-checkbox"
                            data-type="${checkboxType}"
                            data-index="${i}"
                            ${userAdminPermissions.includes(checkboxType) ? "" : "disabled"}
                            ${item.hidden[checkboxType] ? "checked" : ""}
                        >`
            }).join('')

            // don't proceed if "showhiddenOnly" toggle is selected and no values are hidden
            if(!hasHiddenSelections && dataConfig.showHiddenOnly) return;

            // don't proceed if search string does not match any data
            if(dataConfig.query !== "" && item.name.toLowerCase().indexOf(dataConfig.query.toLowerCase()) === -1) return;
            
            // render 'Select All' checkbox if type is 'Companies'
            let selectAllCheckbox = '';
            if(dataConfig.type === "companies" && subscriptions.length > 1) {
                if(checkboxIsAvailable) {
                    selectAllCheckbox = `
                        <input type="checkbox"  
                            data-type="all"
                            data-index="${i}"
                            ${allCheckboxesSelected ? "checked" : ""}
                        >`
                } else {
                    selectAllCheckbox = `<div class='no-record'>—</div>`
                }
            }

            return `
                <div class="data-row" data-id=${item.id}>
                    <div class="name">${item.name}</div>
                    ${checkboxes}
                    ${selectAllCheckbox}
                </div>
            `
        }).join('')

        nodes.dataTableHeader.innerHTML = header;

        if(dataList) {
            nodes.dataList.innerHTML = dataList;
            nodes.dataList.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
                checkbox.addEventListener("click", checkboxShiftEventListener);
                checkbox.addEventListener("change", checkboxEventListener);
            })
        } else {
            nodes.dataList.innerHTML = `<div class="empty-dataset"><div class="message">No results found</div></div>`;
        }

        nodes.loaderElement.classList.add("disabled");
        nodes.saveChanges.classList.remove("success");
    }

    let updateModifiedData = (originalData, modifiedObject) => {
        // remove any current instances of modified object
        modifiedData.some((object, i) => {
            if(object.name === modifiedObject.name) {
                
                modifiedData.splice(i, 1);
            }

            return object.name === modifiedObject.name; // using Array.some so the loop breaks when this is true
        })

        if(JSON.stringify(originalData) !== JSON.stringify(modifiedObject)) {
            // add new modifiedObject to modifiedData
            modifiedData.push(modifiedObject);
        }

        typeSliderConfig.preventSlide = modifiedData.length > 0;
        updateButtonStates();
    }

    let lastCheckedIndex = {
        "csat": null,
        "nps": null,
        "projects": null,
        "all": null
    }

    let checkboxShiftEventListener = (event) => { // event handler to allow for shift+select of multiple rows
        let selectionType = event.target.dataset.type
        

        if(event.shiftKey && lastCheckedIndex[selectionType]) {
            let checkboxes = Array.from(document.querySelectorAll(`.list input[data-type="${selectionType}"]`))
            let start = lastCheckedIndex[selectionType];
            let end = event.target.dataset.index;
            checkboxes.slice(Math.min(start,end), Math.max(start,end)).forEach(checkbox => {
                checkbox.checked = event.target.checked;
                // trigger change event on all updated checkboxes
                checkbox.dispatchEvent(new Event('change', { 'bubbles': true }))
            })
        }

        lastCheckedIndex[selectionType] = event.target.dataset.index;
    }

    let checkboxEventListener = (event) => {
        // get object in data based on index saved to checkbox
        let dataObject = dataStore[dataConfig.type][event.target.dataset.index];        
        let selectionType = event.target.dataset.type

        if(selectionType === "all") {
            // cycle through all hidden keys and set value to match checkbox
            Object.keys(dataObject.hidden).forEach((key, i) => {
                // but only if user has permission
                if(userAdminPermissions.includes(key)) {
                    // update data
                    dataObject.hidden[key] = event.target.checked;
                    // update checkboxes
                    event.target.parentElement.querySelector(`input[data-type="${key}"]`).checked = event.target.checked;
                }
            })
        } else {
            // update data object when checkbox value is changed
            dataObject.hidden[selectionType] = event.target.checked;

            // update 'all' checlbox if necessary
            let allCheckbox = event.target.parentElement.querySelector("input[data-type='all']");
            if(allCheckbox) {
                let uncheckedBox = event.target.parentElement.querySelector("input.type-checkbox:not(:checked):not(:disabled)");
                if(uncheckedBox) {
                    allCheckbox.checked = false;
                } else {
                    allCheckbox.checked = true;
                }
            }            
        }

        updateModifiedData(initialData[dataConfig.type][event.target.dataset.index], dataObject); 
    }

    let addEventListeners = () => {
        nodes.showHiddenOnly.addEventListener("change", (event) => {
            dataConfig.showHiddenOnly = event.target.checked;
            renderList();
        })

        nodes.search.addEventListener("keyup", (event) => {
            setTimeout(() => {
                dataConfig.query = event.target.value;
                renderList();
            }, 400)
        })

        nodes.saveChanges.addEventListener("click", () => {
            nodes.saveChanges.classList.add("loading");
            
            fetch(urls['configuration:data-manager-data'](dataConfig.type), {
                method: "POST",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken,
                },
                body: JSON.stringify(modifiedData)
            }).then(() => {
                nodes.saveChanges.classList.remove("loading");
                nodes.saveChanges.classList.add("success");

                // set intial data to new dataset
                initialData = JSON.parse(JSON.stringify(dataStore));
                // reset modified data, etc
                discardChanges(false);

                setTimeout(() => {
                    nodes.saveChanges.classList.remove("success");
                }, 3000)
            })
        })

        nodes.discardChanges.addEventListener("click", () => {
            createdModal.open(null, function (el) {
                let continueButton = document.querySelector(".sb-modal.discard .continue");
                let primaryText = document.querySelector(".sb-modal.discard .primary-text");
                let secondaryText = document.querySelector(".sb-modal.discard .secondary-text");

                primaryText.innerText = ``
                secondaryText.innerText = `Are you sure you want to discard all changes to '${namingMap[dataConfig.type]}'?`;

                continueButton.addEventListener("click", () => {
                    discardChanges(true);
                    renderList();
                    createdModal.close();
                })
            }, modalTemplate);
        })
    }        

    // this manages the tab slider, and the callback for switching tabs
    let typeSliderConfig = {
        parent: nodes.typeSelectionWrapper,
        slider: nodes.typeSlider,
        preventSlide: false,
        callback: (event) => {
            let changeTabs = () => {
                dataConfig.query = '';
                nodes.search.value = '';
                dataConfig.type = event.target.dataset.type;
                nodes.saveChanges.innerHTML = `Save ${namingMap[dataConfig.type]}`
                nodes.showHiddenOnlySpan.innerText = namingMap[dataConfig.type].toLowerCase()
                renderList();
            }
            
            // show warning when switching tabs with unsaved data
            // and reset tabs upon switching if the user has not saved
            if(modifiedData.length) {
                event.preventDefault();
                createdModal.open(null, function (el) {
                    let continueButton = document.querySelector(".sb-modal.discard .continue");
                    let primaryText = document.querySelector(".sb-modal.discard .primary-text");
                    let secondaryText = document.querySelector(".sb-modal.discard .secondary-text");

                    primaryText.innerText = `Leave '${namingMap[dataConfig.type]}' tab?`
                    secondaryText.innerText = 'You have unsaved changes that will be lost.';

                    continueButton.addEventListener("click", () => {
                        discardChanges(true);
                        changeTabs();
                        createdModal.close();
                        event.target.click();
                    })
                }, modalTemplate);
            } else {
                changeTabs();
            }
        },
    }

    nodes.typeSelections.forEach(type => {    
        // apply slider to each tab at top of page using the config above   
        utilities.applySlider(type, typeSliderConfig)
    })

    return {
        init: function() {
            renderList();
            addEventListeners();
        }
    };
}
);
